<div class="assign-user-conatiner primary-bg">
    <div class="assign-user-header">
        <h2 class=" black-text m-0 lightest-text" [ngStyle]="{'width':'fit-content'}">{{alertVarService.titles.templateTitles.assign_user.users}}</h2> 
        <p class="content-s alert-text" [ngStyle]="{'float':'right'}" *ngIf="showErr">{{alertVarService.titles.templateTitles.assign_user.select_one_error}}</p>

    </div>
    <div class="assign-user-body">
        <div class="custom-search">
            <img src="assets/search-small.svg">
            <input type="search" placeholder="Type to search here" [formControl]="searchValue">
        </div>
        <div class="user-list">
            <ul class=" m-0 p-0" *ngIf="filteredUsers.length">
                <ng-container *ngFor="let user of filteredUsers; index as i">
                    <li [ngClass]="selectedUser?.value==user.value? 'selectable-text content-m p-2':'primary-text content-m p-2'"
                        (click)="selectUser(user)">{{user.disp}}</li>
                </ng-container>
            </ul>
            <p *ngIf="!filteredUsers.length" class="no-users span-l primary-text m-0 pt-5 pr-0 pb-0 pl-0">{{alertVarService.titles.templateTitles.assign_user.no_result}}</p>
        </div>
        <ng-container *ngIf="assignUserSpinnerState">
            <div class="assign-user-spinner">
                <mat-spinner class="spinner" diameter=20></mat-spinner>
            </div>
        </ng-container>
    </div>
    <div class="assign-user-footer">
        <div class="footer-buttons">
            <button class="cancel" (click)="cancelAssigUser()">{{alertVarService.titles.templateTitles.assign_user.cancel}}</button>
            <button class="submit" (click)="submitAssignUser()">{{alertVarService.titles.templateTitles.assign_user.submit}}</button>
        </div>
    </div>
</div>